<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  <ul class="w3-ul w3-margin-top" style="font-size:12px;">
    <h5 style="color:#020202; background:#d3e1e7;" class="px-3 pt-1"><b>ACRs Porforma</b></h5>

    <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
      <!-- <p class="w3-padding-8 w3-left-align"> -->
      <a href="http://cada.hartron.io/assets/home/ACRs%proforma.pdf" target="_blank" class="clickable-text">{{'Porforma 1'| translate}}.</a>
      <!-- </p> -->
  </ul>
<!-- </div> -->